module.exports = __webpack_public_path__ + "packs/media/images/palestraVie3-71e7e7e6c6d87eaa0ef1f79e256e2065.jpg";